import React, { useState } from "react";

import { Alert } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";
import type { TranslatorService } from "@app/services/translator";

export interface UrgencyAlertProps {
  result_search_count: number | null;
  has_results: boolean;
  error_type: string | null;
  has_alternatives: boolean;
  inventory_ready: boolean;
}

export const UrgencyAlert: React.FC<UrgencyAlertProps> = ({
  result_search_count,
  has_results,
  has_alternatives,
  error_type,
  inventory_ready
}) => {
  const { translator } = useAppContext();
  const display_urgency_banner =
    inventory_ready && has_results && (!error_type || has_alternatives);
  const [is_banner_visible, setIsBannerVisible] = useState(
    display_urgency_banner
  );

  const invalid_result_search_count =
    result_search_count === null || result_search_count < 50;

  if (!is_banner_visible || invalid_result_search_count) {
    return null;
  }

  const { title, label } = getUrgencyTexts({
    translator,
    count: result_search_count
  });

  return (
    <Alert
      closeButtonAriaLabel="close alert button"
      severity="notice"
      onClose={() => setIsBannerVisible(false)}
    >
      <Alert.Title as="h2">{title}</Alert.Title>
      <Alert.Description>{label}</Alert.Description>
    </Alert>
  );
};

interface GetUrgencyLabel {
  translator: TranslatorService;
  count: number;
}

function getUrgencyTexts({ translator, count }: GetUrgencyLabel) {
  const hours = "24";
  const texts = {
    title: translator.t("!results.urgency-banner.high-demand.title"),
    label: translator.t("!results.urgency-banner.high-demand.with-data", {
      hours,
      count
    })
  };

  return texts;
}
